// Minimal JS for smooth UX: close mobile menu on nav click, back-to-top button.
(function () {
  // BUG-B112: this used to select ".navbar .nav-link[href^='#']" — every real nav link in this
  // app uses a full URI (via {uri:...}), never a "#..." href, so that selector only ever matched
  // the dropdown-TOGGLE links themselves (class="nav-link dropdown-toggle", href="#", purely a
  // Bootstrap placeholder). Result: clicking a dropdown toggle to OPEN a submenu (e.g. "Kalendarz")
  // immediately closed the whole mobile menu before the submenu could ever be seen. Fix: target
  // what should actually close the menu — real flat nav-links (excluding dropdown-toggles, which
  // only open/close a submenu) and dropdown-menu items (the real navigation targets once a submenu
  // is open).
  const navLinks = [...document.querySelectorAll(".navbar .nav-link:not(.dropdown-toggle), .navbar .dropdown-item")];

  // Close mobile menu on nav link click
  const navbarCollapse = document.querySelector("#navbarNav");
  navLinks.forEach((a) => a.addEventListener("click", () => {
    if (navbarCollapse && navbarCollapse.classList.contains("show")) {
      const bsCollapse = bootstrap.Collapse.getOrCreateInstance(navbarCollapse);
      bsCollapse.hide();
    }
  }));

  // Back to top button
  const backToTop = document.querySelector("#backToTop");
  const toggleBackToTop = () => {
    if (!backToTop) return;
    backToTop.style.display = window.scrollY > 600 ? "block" : "none";
  };
  window.addEventListener("scroll", toggleBackToTop, { passive: true });
  toggleBackToTop();

  backToTop?.addEventListener("click", () => window.scrollTo({ top: 0, behavior: "smooth" }));
})();
